import Vue from 'vue'
import ImagePreview from '@/components/common/ImagePreview.vue'

// 创建图片预览组件实例
let imagePreviewInstance = null

// 创建指令
const imagePreviewDirective = {
  bind(el, binding) {
    // 为元素添加点击事件
    el.addEventListener('click', handleImageClick)
    
    // 为元素内的所有图片添加点击事件
    const images = el.querySelectorAll('img')
    images.forEach(img => {
      img.style.cursor = 'pointer'
      img.addEventListener('click', (e) => {
        e.stopPropagation()
        openImagePreview(img.src, img.alt || '图片')
      })
    })
  },
  
  update(el, binding) {
    // 当内容更新时，重新绑定图片事件
    const images = el.querySelectorAll('img')
    images.forEach(img => {
      img.style.cursor = 'pointer'
      // 移除旧的事件监听器
      img.removeEventListener('click', img._imagePreviewHandler)
      
      // 添加新的事件监听器
      img._imagePreviewHandler = (e) => {
        e.stopPropagation()
        openImagePreview(img.src, img.alt || '图片')
      }
      img.addEventListener('click', img._imagePreviewHandler)
    })
  },
  
  unbind(el) {
    // 清理事件监听器
    el.removeEventListener('click', handleImageClick)
    
    const images = el.querySelectorAll('img')
    images.forEach(img => {
      if (img._imagePreviewHandler) {
        img.removeEventListener('click', img._imagePreviewHandler)
        delete img._imagePreviewHandler
      }
    })
  }
}

// 处理元素点击事件
function handleImageClick(event) {
  if (event.target.tagName === 'IMG') {
    const src = event.target.src
    const alt = event.target.alt || '图片'
    openImagePreview(src, alt)
  }
}

// 打开图片预览
function openImagePreview(imageSrc, imageAlt) {
  if (!imagePreviewInstance) {
    // 创建图片预览组件实例
    const ImagePreviewConstructor = Vue.extend(ImagePreview)
    imagePreviewInstance = new ImagePreviewConstructor({
      propsData: {
        visible: false,
        imageSrc: '',
        imageAlt: ''
      }
    })
    
    // 挂载到body
    imagePreviewInstance.$mount()
    document.body.appendChild(imagePreviewInstance.$el)
    
    // 监听关闭事件
    imagePreviewInstance.$on('close', () => {
      imagePreviewInstance.visible = false
    })
  }
  
  // 显示图片预览
  imagePreviewInstance.imageSrc = imageSrc
  imagePreviewInstance.imageAlt = imageAlt
  imagePreviewInstance.visible = true
}

// 导出指令，以便在main.js中注册
export default imagePreviewDirective
